var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('Navbar'),_c('div',{staticClass:"main-container"},[_c('Sidebar'),_c('AppMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }